<template>
    <!-- 시·분 고르기 ('HH:mm' v-model). 분은 5분 단위, 예전에 저장된 다른 분(예: 07)은 목록에 끼워서 그대로 보이게.
         optional: 시에 '--' (= 값 없음 '') — 일정 끝 시간처럼 선택 항목일 때 -->
    <span class="ts">
        <select class="form-select ts-sel" :value="modelValue ? hour : ''" :aria-label="label + ' 시'" @change="onHour($event.target.value)">
            <option v-if="optional" value="">--</option>
            <option v-for="h in HOURS" :key="h" :value="h">{{ h }}</option>
        </select><span class="ts-unit">시</span>
        <select class="form-select ts-sel" :value="modelValue ? minute : ''" :disabled="!modelValue" :aria-label="label + ' 분'" @change="onMinute($event.target.value)">
            <option v-if="!modelValue" value="">--</option>
            <option v-for="m in minutes" :key="m" :value="m">{{ m }}</option>
        </select><span class="ts-unit">분</span>
    </span>
</template>

<script>
const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0'));   //00 05 10 … 55

export default {
    name: 'TimeSelect',
    props: {
        modelValue: { type: String, default: '' },
        optional: { type: Boolean, default: false },
        defaultTime: { type: String, default: '10:00' },   //optional 이 아닌데 값이 비었을 때 보여줄 시간
        label: { type: String, default: '시간' },
    },
    emits: ['update:modelValue'],
    data() { return { HOURS }; },
    computed: {
        hour() { return (this.modelValue || this.defaultTime).slice(0, 2); },
        minute() { return (this.modelValue || this.defaultTime).slice(3, 5); },
        minutes() {
            const m = this.modelValue ? this.modelValue.slice(3, 5) : null;
            return m && !MINUTES.includes(m) ? [...MINUTES, m].sort() : MINUTES;
        },
    },
    created() {
        //필수 칸인데 비어 있으면 기본 시간으로 채움 (화면과 값이 다르지 않게)
        if (!this.optional && !this.modelValue) this.$emit('update:modelValue', this.defaultTime);
    },
    methods: {
        onHour(h) {
            if (h === '') { this.$emit('update:modelValue', ''); return; }
            this.$emit('update:modelValue', h + ':' + (this.modelValue ? this.minute : '00'));
        },
        onMinute(m) {
            this.$emit('update:modelValue', this.hour + ':' + m);
        },
    },
};
</script>

<style scoped>
    .ts { display: inline-flex; align-items: center; gap: 4px; }
    /* 앱 공통 입력칸 배경 축약(background)이 화살표를 지우는 경우가 있어 직접 그림 */
    .ts .ts-sel, .ts .ts-sel:focus {
        width: 70px; padding: 6px 26px 6px 10px; font-size: 13px !important;
        background-color: #F1F3F7; border: 1px solid transparent; border-radius: 6px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23666' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E");
        background-repeat: no-repeat; background-position: right 8px center; background-size: 12px 12px;
    }
    .ts .ts-sel:focus { background-color: #fff; border-color: #f6951c; box-shadow: none; }
    .ts .ts-sel:disabled { opacity: .55; }
    .ts .ts-unit { color: #555; font-size: 13px !important; margin-right: 2px; }
    @media (max-width: 768px) {
        .ts .ts-sel, .ts .ts-sel:focus { font-size: 16px !important; width: 76px; }   /* iOS 확대 방지 */
        .ts .ts-unit { font-size: 14px !important; }
    }
</style>
